import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {loadingIndicatorAttrs} from 'notebook/util/ExportInstrumentation';
import getTestProps from 'test/lib/cypress/getTestProps';
import Spinner from 'ui-library/Spinner';

/**
 * @deprecated This component has been deprecated in favor of a rotating circular spinner. Please ese
 * `Spinner` directly instead.
 */
export default function HorizontalThrobber(): JSX.Element {
  return (
    <Spinner
      aria-label="Loading..."
      {...loadingIndicatorAttrs()}
      {...getTestProps({component: 'HorizontalThrobber', element: 'root'})}
    />
  );
}

interface CenteredHorizontalThrobberProps {
  suppressPadding?: boolean;
  className?: string;
}

/**
 * @deprecated This component has been deprecated in favor of a rotating circular spinner. Please ese
 * `CenteredSpinner` directly instead.
 */
export function CenteredHorizontalThrobber({
  suppressPadding = false,
  className,
}: CenteredHorizontalThrobberProps): JSX.Element {
  return (
    <div
      className={classNames(
        css(styles.centeringWrapper),
        {[css(styles.paddedWrapper)]: !suppressPadding},
        className
      )}
    >
      <HorizontalThrobber />
    </div>
  );
}

const styles = StyleSheet.create({
  centeringWrapper: {
    textAlign: 'center',
    overflowY: 'hidden',
  },
  paddedWrapper: {
    padding: '20px 34px 20px',
  },
});
